module.exports = __webpack_public_path__ + "media/images/saint vincent et grenadines-7d52d882c7e59a71d6cf0ed77a673180.svg";